export const moneyObjectHeader = {
  'X-Money-Object': 'true',
}
